<template>
  <div v-if="pageCount > 1" class="flex justify-center items-center flex-wrap mt-8">
    <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="pagination-btn px-4 py-2 mx-1 rounded">&laquo; Trước</button>
    <template v-for="(page, index) in pages" :key="index">
      <span v-if="page === '...'" class="px-4 py-2 mx-1 text-gray-500">...</span>
      <button
        v-else
        @click="changePage(page)"
        :class="{ active: page === currentPage }"
        class="pagination-btn px-4 py-2 mx-1 rounded"
      >
        {{ page }}
      </button>
    </template>
    <button @click="changePage(currentPage + 1)" :disabled="currentPage === pageCount" class="pagination-btn px-4 py-2 mx-1 rounded">Sau &raquo;</button>
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  props: {
    totalItems: Number,
    itemsPerPage: Number,
    currentPage: Number,
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    pages() {
      const pageCount = this.pageCount;
      const currentPage = this.currentPage;

      // Cấu hình:
      // - pagesInMiddle: Số trang hiển thị ở giữa (quanh trang hiện tại). Nên là số lẻ.
      // - pagesAtEdges: Số trang hiển thị ở đầu và cuối (không tính trang 1 và trang cuối cùng).
      const pagesInMiddle = 3;
      const pagesAtEdges = 2;
      const totalPagesToShow = pagesInMiddle + (pagesAtEdges * 2) + 2; // +2 for first and last page

      // Nếu tổng số trang ít, hiển thị tất cả
      if (pageCount <= totalPagesToShow) {
        return Array.from({length: pageCount}, (_, i) => i + 1);
      }

      const range = [];

      // Trường hợp 1: Trang hiện tại ở gần đầu
      if (currentPage <= pagesAtEdges + Math.ceil(pagesInMiddle / 2)) {
        const endRange = pagesAtEdges + pagesInMiddle;
        for (let i = 1; i <= endRange; i++) {
          range.push(i);
        }
        range.push('...');
        range.push(pageCount);
      }
      // Trường hợp 2: Trang hiện tại ở gần cuối
      else if (currentPage > pageCount - (pagesAtEdges + Math.ceil(pagesInMiddle / 2))) {
        range.push(1);
        range.push('...');
        const startRange = pageCount - (pagesAtEdges + pagesInMiddle - 1);
        for (let i = startRange; i <= pageCount; i++) {
          range.push(i);
        }
      }
      // Trường hợp 3: Trang hiện tại ở giữa
      else {
        range.push(1);
        range.push('...');
        const middleStart = currentPage - Math.floor(pagesInMiddle / 2);
        for (let i = 0; i < pagesInMiddle; i++) {
          range.push(middleStart + i);
        }
        range.push('...');
        range.push(pageCount);
      }

      return range;
    }
  },
  methods: {
    changePage(page) {
      if (typeof page === 'number' && page > 0 && page <= this.pageCount) {
        this.$emit('page-changed', page);
      }
    },
  },
};
</script>

<style scoped>
/* Giữ nguyên các style từ file index.html */
.pagination-btn {
  background-color: var(--card-bg-color);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  transition: background-color 0.2s, border-color 0.2s;
}

.pagination-btn:hover:not(:disabled) {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.pagination-btn.active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
